import axios from "../lib/axios-config";
const getSubscriptionDetails = ()=>axios.get("/subscription/details");
export const SubscriptionApi = {
    getSubscriptionDetails
};
